<template>
  <div class="row">
    <div
        v-for="(item, index) in summaryItems"
        :key="index"
        class="col-sm-12 col-md-6 col-lg-3"
    >
      <Loader :loading="loading" class="bg-white-loader" no-axios>
        <b-card :sub-title="item.label">
          <b class="customer-metric-bold">{{ formatValue(item.count) }}</b>
        </b-card>
      </Loader>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/widgets/loader";

export default {
  name: "CustomerSummary",
  components: {Loader},
  props: {
    summary: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    summaryItems() {
      return Object.keys(this.summary).map((key) => {
        return {
          label: this.label(key),
          count: this.summary[key],
        }
      })
    },
  },
  methods: {
    formatValue(value) {
      return this.$numeral(value).format('0,0.[00]')
    },
    label(key) {
      if (key === 'typeFarmer') {
        return `Total ${this.$t('customers.types.farmer')}`
      } else if (key === 'typePartner') {
        return `Total ${this.$t('customers.types.partner')}`
      } else if (key === 'typeProcessing') {
        return `Total ${this.$t('customers.types.processing')}`
      }

      return `Total ${this.$t('customers.singular')}`
    }
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .bg-white-loader {
    .preloader-component {
      background: rgba(255, 255, 255, 0.5) !important;
    }
  }
}
</style>
